import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { environment } from 'environments/environment';
import { PreloaderService } from 'shared/services/preloader.service';
import axios from 'axios';
import { ModalService } from 'shared/services/modal.service';
import { AlertService } from 'shared/services/alert.service';
import { previsitBlockreason, previsitNAreason } from 'shared/models/static-list-data.service';
import { AuthService } from 'shared/services/authentication.service';


@Component({
  selector: 'app-previsit-checklist',
  templateUrl: './previsit-checklist.component.html',
  styleUrls: ['./previsit-checklist.component.css']
})
export class PrevisitChecklistComponent implements OnInit {
  statusCounts: { [status: string]: number } = {};
  @Input()
  set selectedJob(e) {
    this._selectedJob = e;
    // console.log(e)
    this.getPrevisitChecklist(e.id)
  }
  _selectedJob: any;
  selectedFiles: File[] = [];
  progress = {};
  previsitForm: FormGroup;
  checkListData = [];
  isLoading = true;
  currentUser: any;
  selectedFilesNames: { [key: number]: File[] } = {};
  showReason = false;
  previsitReason: any;
  textHeader = '';
  textlabel = '';
  previsitStatus = '';
  selectedId = '';
  constructor(
    private _fb: FormBuilder,
    private _preloaderService: PreloaderService,
    private _modalService: ModalService,
    private _alertService: AlertService,
    private auth: AuthService
  ) { }
  ngOnInit() {
    const appData = JSON.parse(localStorage.getItem('appData'));
    this.currentUser = appData && appData.user;
  }

  initializeForm() {
    this.previsitForm = this._fb.group({
      reasonlist: new FormControl(null, [Validators.required]),

    });
  }

  updateStatus(id, status) {
    this.showReason = true
    if (status == 'na') {
      this.textlabel = 'Select a reason why this item does not apply';
      // this.previsitForm.get('notApplicableReasonText').setValidators([Validators.required]);
      // this.previsitForm.get('notApplicableReasonText').updateValueAndValidity();
      // this.previsitForm.get('blockedReasonText').clearValidators();
      // this.previsitForm.get('blockedReasonText').updateValueAndValidity();
      this.previsitReason = previsitNAreason;
      this.previsitStatus = 'not_applicable';
    }
    else if (status == 'blocked') {
      this.textlabel = 'Select a reason why this item is blocked';
      // this.previsitForm.get('blockedReasonText').setValidators([Validators.required]);
      // this.previsitForm.get('blockedReasonText').updateValueAndValidity(); 
      this.previsitReason = previsitBlockreason;
      this.previsitStatus = 'blocked';

    }
    this.selectedId = id;
    this.initializeForm();
  }


  submitRequest() {
    this._preloaderService.showPreloader();
    const data = this.previsitForm.value;
    const url = environment.phoenixURL + '/jobs/' + this._selectedJob.id + '/checklists/' + this.selectedId;
    let postBody = {};
    if (this.previsitStatus == 'not_applicable') {
      postBody = {
        status: this.previsitStatus,
        notApplicableReasonText: data.reasonlist
      }
    } else if (this.previsitStatus == 'blocked') {
      postBody = {
        status: this.previsitStatus,
        blockedReasonText: data.reasonlist
      }
    }

    const that = this;

    axios.post(url, postBody).then(function (response) {
      that._alertService.success('Checklist submitted successfully.');
      that._preloaderService.hidePreloader();
      that.showReason = false;
      that.getPrevisitChecklist(that._selectedJob.id)
    }).catch(function (error) {
      that._preloaderService.hidePreloader();
      that._alertService.error('Please try again .');
    });
  }

  closeForm() {
    this.showReason = false;
    this.initializeForm();

  }

  getPrevisitChecklist(jobId) {
    this._preloaderService.showPreloader();
    const url = environment.phoenixURL + '/jobs/' + jobId + '/checklists';
    const that = this;

    axios.get(url)

      .then(function (response) {
        that.isLoading = false;
        that._preloaderService.hidePreloader();
        let data = response.data && response.data.data ? response.data.data : [];
        // Sort so that 'pending' status items are at the top
        data = data.slice().sort((a, b) => {
          if (a.status === 'pending' && b.status !== 'pending') return -1;
          if (a.status !== 'pending' && b.status === 'pending') return 1;
          return 0;
        });
        that.checkListData = data;
        that.statusCounts = that.getStatusCounts(that.checkListData);
        console.log('that.statusCounts', that.statusCounts);
      }).catch(function (error) {
        that.isLoading = false;
        that._preloaderService.hidePreloader();
      });
  }

  getStatusCounts(data: any[]): { [status: string]: number } {
    const counts: { [status: string]: number } = {};
    data.forEach(item => {
      const status = item.status || 'unknown';
      counts[status] = (counts[status] || 0) + 1;
    });
    return counts;
  }


  onFileSelected(event, index) {
    const file: File = event.target.files[0];
    this.selectedFiles = Array.from(event.target.files);
    this.selectedFilesNames[index] = Array.from(event.target.files);
  }


  closePopup() {
    this._modalService.closed();
  }

  confirm(id, docRes) {
    this._preloaderService.showPreloader();
    const url = environment.phoenixURL + '/jobs/' + this._selectedJob.id + '/checklists/' + id;
    const that = this;
    const postBody = {
      status: 'confirmed'
    }

    axios.post(url, postBody).then(function (response) {
      that._alertService.success('Checklist submitted successfully.');
      that._preloaderService.hidePreloader();
      that.getPrevisitChecklist(that._selectedJob.id)
    }).catch(function (error) {
      that._preloaderService.hidePreloader();
      that._alertService.error('Please try again .');
    });
  }
    onChangeCertification (e) {
  //  if (e.target.value === 'Other') {
  //   this.showOther = true;
  //   this.deliverablesForm.controls['Other__c'].setValue(null);
  //   this.deliverablesForm.controls['Other__c'].setValidators([Validators.required]);
  //  }else{
  //    this.showOther = false;
  //     this.deliverablesForm.controls['Other__c'].setValidators(null);
  //     this.deliverablesForm.controls['Other__c'].setValue(null);
  //   }
  }

}
